export const MODERATION_CONTENT_TYPE = {
    DISCUSSION: 'discussion',
    COMMENT: 'comment',
};
export const MODERATION_FLAG_TYPE = {
    FLAG: 'flag',
    RATING: 'rating',
};
export const MODERATION_STATUS = {
    UNREVIEWED: 'unreviewed',
    PENDING: 'pending',
    APPROVED: 'approved',
    REVIEWED: 'reviewed',
    DISMISSED: 'dismissed',
    REMOVED: 'removed',
};
